/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
// import { AdminBookInfomation } from './book-Infomation';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as toast from '../../../_store/slice/toast';
import server from '../../../_api/backend';

import { RelatedBooks } from './relatedBooks';

const flagEdition = [
  { id: '0', text: '초판' },
  { id: '1', text: '재판' },
];

type Params = {
  id: number;
};

export function AdminDetailBook(routeProps: RouteComponentProps) {
  const history = useHistory();
  const { match, location } = routeProps;
  const { id } = match.params as Params;

  const [check, setCheck] = useState<any>();

  // 업로드된 파일
  const [attachedFiles, setAttachedFiles] = useState<any[]>([]);
  // 업로드예정 파일
  const [attachingFiles, setAttachingFiles] = useState<File[]>([]);
  const [attachingMiddleImgView, setAttachingMiddleImgView] = useState<any>(null);
  const [attachingDetailImgView, setAttachingDetailImgView] = useState<any>(null);
  // 삭제예정 파일
  const [removingFiles, setRemovingFiles] = useState<any[]>([]);

  // 업로드 된 파일 ( 서버에서 가져온 파일 )
  const [attachedSmallImg, setAttachedSmallImg] = useState<any>();
  const [attachedMiddleImg, setAttachedMiddleImg] = useState<any>();
  const [attachedMainImg, setAttachedMainImg] = useState<any>();
  const [attachedDetailImg, setAttachedDetailImg] = useState<any>();

  // 업로드 예정 파일 ( 추가하는 이미지 파일 )
  const [attachingSmallImg, setAttachingSmallImg] = useState<File>();
  const [attachingMiddleImg, setAttachingMiddleImg] = useState<any>();
  const [attachingMainImg, setAttachingMainImg] = useState<File>();
  const [attachingDetailImg, setAttachingDetailImg] = useState<any>();

  // 삭제 예정 파일
  const [removingSmallImg, setRemovingSmallImg] = useState<string>('');
  const [removingMiddleImg, setRemovingMiddleImg] = useState<string>('');
  const [removingMainImg, setRemovingMainImg] = useState<string>('');
  const [removingDetailImg, setRemovingDetailImg] = useState<string>('');

  const dispatch = useDispatch();
  const [bookItem, setBookItem] = useState<any>({});
  const [categories, setCategories] = useState<any>([]);
  const [subCategory, setSubCategory] = useState<any[]>([]);
  const [categoryName, setCategoryName] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedSubCategory, setSelectedSubCategory] = useState<number>(0);
  const [bookName, setBookName] = useState<string>('');
  const [bookPrice, setBookPrice] = useState<number>(0); // 판매가
  const [bookPriceFull, setBookPriceFull] = useState<number>(0); // 정상가
  const [bookPriceMember, setBookPriceMember] = useState<number>(0);
  const [bookPriceNonmember, setBookPriceNonmember] = useState<number>(0);
  const [bookPoint, setBookPoint] = useState<number>(0);
  const [bookFlagType, setBookFlagType] = useState<string>('0');
  const [selectedEdition, setSelectedEdition] = useState<string>('');
  const [sizeType, setSizeType] = useState<string>('');
  const [isColorBook, setIsColorBook] = useState<string>('');
  const [hasCD, setHasCD] = useState<string>('');
  const [hasVideos, setHasVideos] = useState<string>('');
  const [bookCollege, setBookCollege] = useState<string>('');
  const [publicationDate, setPublicationDate] = useState<string>('');
  const [bookQty, setBookQty] = useState<number>(0);
  const [bookPageCount, setBookPageCount] = useState<number>(0);
  const [publisher, setPublisher] = useState<string>('');
  const [urlMovies, setUrlMovies] = useState<string>('');
  const [urlYoutubes, setUrlYoutubes] = useState<string>('');
  const [urlBlogs, setUrlBlogs] = useState<string>('');
  const [bookisbn, setBookIsbn] = useState<string>('');
  const [bookIntroduce, setBookIntroduce] = useState<string>('');
  const [bookContents, setBookContents] = useState<string>('');
  const [bookAuthor, setBookAuthor] = useState<string>('');
  const [bookAuthorIntroduce, setBookAuthorIntroduce] = useState<string>('');
  const [isMainBook, setIsMainBook] = useState<string>('');
  const [isBestBook, setIsBestBook] = useState<string>('');
  const [isNewBooks, setIsNewBooks] = useState<string>('');
  const [isRecommendBook, setIsRecommendBook] = useState<string>('');
  const [isDisplayBook, setIsDisplayBook] = useState<string>('');

  const [isShowRelated, setIsShowRelated] = useState<boolean>(false);

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getCategoryList().then(() => {
      getBookDetail();
      categoryNameSelect();
    });
  }, []);

  const getBookDetail = async () => {
    if (id !== undefined) {
      await server
        .getBookDetail(id)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setBookItem(payload);
            setCategoryName(payload.category.parentId);
            setSelectedSubCategory(payload.categoryId);
            setBookName(payload.name);
            setBookPriceFull(Number(payload.priceFull));
            setBookPrice(Number(payload.price));
            setBookPriceMember(Number(payload.priceMember));
            setBookPriceNonmember(Number(payload.priceNonmember));
            setBookPoint(Number(payload.point));
            setBookFlagType(payload.flagType);
            setSelectedEdition(payload.flagEdition);
            setSizeType(payload.size);
            setIsColorBook(payload.isColor);
            setHasCD(payload.hasCd);
            setHasVideos(payload.hasVideo);
            setBookCollege(payload.college);
            setPublicationDate(payload.publicationDate);
            setBookQty(Number(payload.qty));
            setBookPageCount(Number(payload.pageCount));
            setPublisher(payload.publisher);
            setUrlMovies(payload.urlMovie);
            setUrlYoutubes(payload.urlYoutube);
            setUrlBlogs(payload.urlBlog);
            setBookIsbn(payload.isbn);
            setBookIntroduce(payload.introduce);
            setBookContents(payload.contents);
            setBookAuthor(payload.author);
            setBookAuthorIntroduce(payload.authorIntroduce);
            setIsMainBook(payload.isMain);
            setIsBestBook(payload.isBest);
            setIsNewBooks(payload.isNew);
            setIsRecommendBook(payload.isRecommendation);
            setIsDisplayBook(payload.isDisplay);
            setAttachedSmallImg(payload.imageSmallUrl);
            setAttachedMiddleImg(payload.imageMiddleUrl);
            setAttachedMainImg(payload.imageMainUrl);
            setAttachedDetailImg(payload.imageDetailUrl);
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  const getCategoryList = async () => {
    await server
      .getCategories()
      .then((payload) => {
        setCategories(payload);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // const isbnRule = /^(?:ISBN(?:-13)?:? )?(?=[0-9]{13}$|(?=(?:[0-9]+[- ]){4})[- 0-9]{17}$)97[89][- ]?[0-9]{1,5}[- ]?[0-9]+[- ]?[0-9]+[- ]?[0-9]$/;

  // const dateRule = /^\d{4}[/-]\d{2}[/-]\d{2}$/; // 발간일 정규 표현식

  const isbnRule = /^\d{3}[/-]\d{2}[/-]\d{4}[/-]\d{3}[/-]\d{1}$/; // isbn 정규 표현식 ( 111-11-1111-111-1 )

  const isbnRule2 = /^\d{3}[/-]\d{2}[/-]\d{4}[/-]\d{3}[/-]\d{1}\s?\d{2,3}$/; // isbn 정규 표현식 ( 111-11-1111-111-1 23) - 띄어쓰기 포함

  const onClickValidation = async () => {
    if (!categories) {
      dispatch(toast.error({ message: '카테고리를 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (!subCategory) {
      dispatch(
        toast.error({ message: '서브 카테고리를 선택해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (bookName.length < 0 || bookName === undefined) {
      dispatch(toast.error({ message: '도서명을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPriceFull <= 0) {
      dispatch(toast.error({ message: '정가를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPrice <= 0) {
      dispatch(toast.error({ message: '판매가를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookPriceNonmember <= 0) {
      dispatch(
        toast.error({ message: '비회원가격을 입력해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (bookFlagType.length <= 0) {
      dispatch(toast.error({ message: '구분을 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (selectedEdition.length <= 0) {
      dispatch(
        toast.error({ message: '출간구분 값을 선택해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (publicationDate.length <= 0) {
      dispatch(toast.error({ message: '발간일을 확인해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    // if (!dateRule.test(publicationDate)) {
    //   dispatch(
    //     toast.error({
    //       message: '발간일을 확인해주세요.',
    //       title: '필수 입력 항목 누락 또는 발간일 형식이 맞지 않습니다.',
    //     })
    //   );
    //   return;
    // }
    if (bookPageCount <= 0) {
      dispatch(toast.error({ message: '페이지수를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (publisher.length <= 0) {
      dispatch(toast.error({ message: '출판사를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (bookisbn.length <= 0) {
      dispatch(toast.error({ message: '도서 ISBN을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    onClickUpdateBook(id);
    // if (isbnRule.test(bookisbn) || isbnRule2.test(bookisbn)) {
    //   onClickUpdateBook(id);
    // } else {
    //   dispatch(
    //     toast.error({
    //       message: 'ISBN을 확인해주세요.',
    //       title: '필수 입력 항목 누락 또는 ISBN 형식이 맞지 않습니다.',
    //     })
    //   );
    // }
    // if (!bookAuthor) {
    //   dispatch(toast.error({ message: '저자 이름을 입력해주세요.', title: '필수 입력 항목 누락' }));
    //   return;
    // }
  };

  const onClickUpdateBook = async (bookId: any) => {
    if (window.confirm(`수정 하시겠습니까?`)) {
      const savedBook = await server
        .updateBook(bookId, {
          category: +selectedSubCategory,
          name: bookName,
          size: sizeType,
          isbn: bookisbn,
          pageCount: bookPageCount,
          college: bookCollege,
          author: bookAuthor,
          authorIntroduce: bookAuthorIntroduce,
          introduce: bookIntroduce,
          contents: bookContents,
          qty: bookQty,
          point: bookPoint,
          price: bookPrice,
          priceFull: bookPriceFull,
          priceMember: bookPriceMember,
          priceNonmember: bookPriceNonmember,
          flagType: bookFlagType,
          flagEdition: selectedEdition,
          isMain: isMainBook,
          isBest: isBestBook,
          isNew: isNewBooks,
          isRecommendation: isRecommendBook,
          isDisplay: isDisplayBook,
          isColor: isColorBook,
          hasCd: hasCD,
          hasVideo: hasVideos,
          urlYoutube: urlYoutubes,
          urlBlog: urlBlogs,
          urlMovie: urlMovies,
          publicationDate,
          publisher,
        })
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로 부터 응답이 없습니다.' }));
          } else if (payload.code === 400 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          }
          history.push('/admin/book/list/all');
          return payload;
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });

      if (savedBook !== undefined) {
        if (
          attachingSmallImg !== undefined ||
          attachingMiddleImg !== undefined ||
          attachingMainImg !== undefined ||
          attachingDetailImg !== undefined
        ) {
          await server
            .fileUploadBooks(id, {
              imageSmall: attachingSmallImg,
              imageMiddle: attachingMiddleImg,
              imageMain: attachingMainImg,
              imageDetail: attachingDetailImg,
            })
            .catch((error) => {
              dispatch(toast.error({ message: '첨부파일 에러.' }));
              return error;
            });
          history.push('/admin/book/list/all');
        }
      }
      // 파일 지우는 로직 필요
    }
  };

  // 도서 이미지 미리보기 (도서 중간이미지)
  function attachingMiddleImgBlob(event: any) {
    const imageFile = event;
    if (imageFile === undefined) {
      const imageUrl = URL.createObjectURL(attachingMiddleImg);
      setAttachingMiddleImgView(imageUrl);
    } else {
      const imageUrl = URL.createObjectURL(imageFile);
      setAttachingMiddleImg(imageFile);
      setAttachingMiddleImgView(imageUrl);
    }
  }

  // 도서 이미지 미리보기 (도서 상세이미지)
  function attachingDetailImgBlob(event: any) {
    const imageFile = event;
    if (imageFile === undefined) {
      const imageUrl = URL.createObjectURL(attachingDetailImg);
      setAttachingDetailImgView(imageUrl);
    } else {
      const imageUrl = URL.createObjectURL(imageFile);
      setAttachingDetailImg(imageFile);
      setAttachingDetailImgView(imageUrl);
    }
  }

  const categoryNameSelect = () => {
    let name = '';

    for (let i = 0; i < categories.length; i++) {
      if (categories.id === categoryName) {
        name = categories.name;
      }
    }
    setCategoryName(name);
  };

  return (
    <main className="new wrapper">
      <div className="title">
        <h1>{id !== undefined ? '도서 정보 수정' : '신규 도서 등록'}</h1>
        <div className="buttons">
          <button type="button" onClick={() => onClickValidation()}>
            저장
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="book-categories">
            <span className="required">카테고리</span>
            <div>
              <div className="selectbox">
                <select
                  name="categoryBox"
                  id="categoryBox"
                  value={categoryName}
                  onChange={(option: any) => {
                    const val = option.target.value;
                    setCategoryName(val);
                    setSelectedCategory(val);
                    setSelectedSubCategory(0);
                    const child = categories.find((category: any) => category.id === val);
                    if (child && child.children) {
                      setSubCategory(child.children);
                      setSelectedSubCategory(child.children[0].id);
                    }
                  }}
                >
                  {categories &&
                    categories.map((parent: any, i: any) => (
                      <option key={parent.id} value={parent.id}>
                        {parent.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="selectbox">
                <select
                  name="subCategoryBox"
                  id="subCategoryBox"
                  onChange={(option: any) => {
                    const val = option.target.value;
                    setSelectedSubCategory(val);
                  }}
                >
                  {subCategory.map((category: any) => (
                    <option value={category.id} key={category.id}>
                      {category.name}
                    </option>
                  ))}
                  {selectedSubCategory === bookItem.categoryId ? (
                    <option value={bookItem.category.id}> {bookItem.category.name}</option>
                  ) : (
                    <></>
                  )}
                </select>
              </div>
            </div>
          </li>
          <li className="col-3 book-codes">
            <div className="col">
              <span>카테고리 코드</span>
              <input
                readOnly
                type="number"
                defaultValue={selectedSubCategory || bookItem.categoryId}
              />
            </div>
            <div className="col">
              <span>도서 코드</span>
              <input readOnly type="number" defaultValue={bookItem?.code ? bookItem?.code : ''} />
            </div>
          </li>
          <li className="book-title">
            <span className="required">도서명</span>
            <input
              className="full"
              type="text"
              defaultValue={bookItem.name || ''}
              onChange={(e: any) => {
                setBookName(e.target.value);
              }}
            />
          </li>
          <li className="price">
            <span className="required">정가</span>
            <input
              type="number"
              defaultValue={bookItem.priceFull || ''}
              onChange={(e: any) => {
                setBookPriceFull(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="price">
            <span className="required">판매가</span>
            <input
              type="number"
              defaultValue={bookItem.price || ''}
              onChange={(e: any) => {
                setBookPrice(Number(e.target.value));
              }}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="price">
            <span>회원가격</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPriceMember(Number(e.target.value));
              }}
              defaultValue={bookItem.priceMember || ''}
              placeholder="숫자만 입력하세요."
            />
            <small>※ (대학교재는 할인단가)</small>
          </li>
          <li className="price">
            <span className="required">비회원가격</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPriceNonmember(Number(e.target.value));
              }}
              defaultValue={bookItem.priceNonmember || ''}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="mileage">
            <span>구매포인트</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPoint(Number(e.target.value));
              }}
              defaultValue={bookItem.point || ''}
              placeholder="숫자만 입력하세요."
            />
          </li>
          <li className="input">
            <span className="required">구분</span>
            <div className="selectbox">
              <select
                name="flagTypeBox"
                id="flagTypeBox"
                onChange={(e: any) => {
                  setBookFlagType(e.target.value);
                }}
                value={bookFlagType}
              >
                <option value="0">단행본</option>
                <option value="1">전공서적</option>
                <option value="2">수험서</option>
                <option value="3">기타</option>
              </select>
            </div>
          </li>
          <li className="input">
            <span className="required">출간구분</span>
            <input
              id="publish01"
              type="radio"
              name="publish"
              onChange={() => setSelectedEdition('0')}
              checked={selectedEdition === '0'}
            />
            <label htmlFor="publish01">초판</label>
            <input
              id="publish02"
              type="radio"
              name="publish"
              onChange={() => setSelectedEdition('1')}
              checked={selectedEdition === '1'}
            />
            <label htmlFor="publish02">재판</label>
          </li>
          <li className="input">
            <span>판형</span>
            <input
              type="text"
              onChange={(e) => {
                setSizeType(e.target.value);
              }}
              defaultValue={bookItem.size || ''}
            />
          </li>
          <li className="input">
            <span>컬러</span>
            <input
              id="noColor"
              type="radio"
              name="color"
              onChange={() => setIsColorBook('N')}
              checked={isColorBook === 'N'}
            />
            <label htmlFor="noColor">없음</label>
            <input
              id="yesColor"
              type="radio"
              name="color"
              onChange={() => setIsColorBook('Y')}
              checked={isColorBook === 'Y'}
            />
            <label htmlFor="yesColor">있음</label>
          </li>
          <li className="input">
            <span>CD</span>
            <input
              id="noCD"
              type="radio"
              name="CD"
              onChange={() => setHasCD('N')}
              checked={hasCD === 'N'}
            />
            <label htmlFor="noCD">없음</label>
            <input
              id="yesCD"
              type="radio"
              name="CD"
              onChange={() => setHasCD('Y')}
              checked={hasCD === 'Y'}
            />
            <label htmlFor="yesCD">있음</label>
          </li>
          <li className="input">
            <span>동영상</span>
            <input
              id="noVideo"
              type="radio"
              name="video"
              onChange={() => setHasVideos('N')}
              checked={hasVideos === 'N'}
            />
            <label htmlFor="noVideo">없음</label>
            <input
              id="yesVideo"
              type="radio"
              name="video"
              onChange={() => setHasVideos('Y')}
              checked={hasVideos === 'Y'}
            />
            <label htmlFor="yesVideo">있음</label>
          </li>
          <li>
            <span>대학명</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookCollege(e.target.value);
              }}
              defaultValue={bookItem.college || ''}
            />
            <small>※ 대학교재일 때에는 대학배너의 대학명과 반드시 동일하게 적어주세요.</small>
          </li>
          <li>
            <span className="required">발간일</span>
            <input
              type="text"
              onChange={(e: any) => {
                setPublicationDate(e.target.value);
              }}
              defaultValue={
                bookItem.publicationDate
                  ? new Date(bookItem.publicationDate).toLocaleDateString()
                  : ''
              }
            />
            <small>※ 입력 형식: 2021-06-25</small>
          </li>
          <li>
            <span>수량</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookQty(Number(e.target.value));
              }}
              value={bookQty || 0}
            />
            <small>※ 품절일 경우 &quot;0&quot;으로 입력해주세요.</small>
          </li>
          <li className="input">
            <span className="required">페이지수</span>
            <input
              type="number"
              onChange={(e: any) => {
                setBookPageCount(Number(e.target.value));
              }}
              value={bookPageCount || 0}
            />
          </li>
          <li className="input">
            <span className="required">출판사</span>
            <input
              type="text"
              onChange={(e: any) => {
                setPublisher(e.target.value);
              }}
              defaultValue={bookItem.publisher || ''}
            />
          </li>
          <li>
            <span>Youtube</span>
            <input
              type="url"
              onChange={(e: any) => {
                setUrlYoutubes(e.target.value);
              }}
              defaultValue={bookItem.urlYoutube || ''}
            />
          </li>
          <li>
            <span>Blog</span>
            <input
              type="url"
              onChange={(e: any) => {
                setUrlBlogs(e.target.value);
              }}
              defaultValue={bookItem.urlBlog || ''}
            />
          </li>
          <li>
            <span className="required">ISBN</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookIsbn(e.target.value);
              }}
              defaultValue={bookItem.isbn || ''}
            />
            {/* <small>※ 형식: 9788970746193의 13자리의 숫자만</small> */}
          </li>
          <li>
            <span>도서소개 및 특징</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookIntroduce(e.target.value);
              }}
              defaultValue={bookItem.introduce || ''}
            />
          </li>
          <li>
            <span>목차</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookContents(e.target.value);
              }}
              defaultValue={bookItem.contents || ''}
            />
          </li>
          <li>
            <span className="required">저자이름</span>
            <input
              type="text"
              onChange={(e: any) => {
                setBookAuthor(e.target.value);
              }}
              defaultValue={bookItem.author || ''}
            />
          </li>
          <li>
            <span>저자소개</span>
            <textarea
              rows={10}
              onChange={(e: any) => {
                setBookAuthorIntroduce(e.target.value);
              }}
              defaultValue={bookItem.authorIntroduce || ''}
            />
          </li>
          <li>
            <span>도서 이미지 (247x315)</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  if (e.target !== null && e.target.files !== null) {
                    attachingMiddleImgBlob(e.target.files[0]);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <small className="file-return">
              {attachingMiddleImgView === null ? (
                <img src={`${process.env.REACT_APP_API_URL}/public${attachedMiddleImg}`} alt="" />
              ) : (
                <img src={attachingMiddleImgView} alt="" />
              )}
            </small>
          </li>
          <li>
            <span>상세내용 이미지 (가로사이즈: 610px)</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file04"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  if (e.target !== null && e.target.files !== null) {
                    attachingDetailImgBlob(e.target.files[0]);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file04" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <small className="file-return">
              {!attachingDetailImgView ? (
                <img src={`${process.env.REACT_APP_API_URL}/public${attachedDetailImg}`} alt="" />
              ) : (
                <img src={attachingDetailImgView} alt="" />
              )}
            </small>
          </li>
          <li>
            <span>도서 유형구분</span>
            <div className="checkboxes">
              <div className="checkbox">
                <input
                  id="bookType01"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsMainBook(e.target.checked);
                    if (isMainBook === 'N') {
                      setIsMainBook('Y');
                    } else {
                      setIsMainBook('N');
                    }
                  }}
                  checked={isMainBook === 'Y'}
                />
                <label htmlFor="bookType01">메인도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType02"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsBestBook(e.target.value);
                    if (isBestBook === 'N') {
                      setIsBestBook('Y');
                    } else {
                      setIsBestBook('N');
                    }
                  }}
                  checked={isBestBook === 'Y'}
                />
                <label htmlFor="bookType02">BEST도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType03"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsNewBooks(e.target.checked);
                    if (isNewBooks === 'N') {
                      setIsNewBooks('Y');
                    } else {
                      setIsNewBooks('N');
                    }
                  }}
                  checked={isNewBooks === 'Y'}
                />
                <label htmlFor="bookType03">신간도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType04"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsRecommendBook(e.target.checked);
                    if (isRecommendBook === 'N') {
                      setIsRecommendBook('Y');
                    } else {
                      setIsRecommendBook('N');
                    }
                  }}
                  checked={isRecommendBook === 'Y'}
                />
                <label htmlFor="bookType04">추천도서</label>
              </div>
              <div className="checkbox">
                <input
                  id="bookType05"
                  type="checkbox"
                  onChange={(e: any) => {
                    setIsDisplayBook(e.target.checked);
                    if (isDisplayBook === 'N') {
                      setIsDisplayBook('Y');
                    } else {
                      setIsDisplayBook('N');
                    }
                  }}
                  checked={isDisplayBook === 'Y'}
                />
                <label htmlFor="bookType05">전시도서</label>
              </div>
            </div>
          </li>
          {/* <li className="choose-books">
            <span>관련도서</span>
            <div>
              <button
                onClick={() => {
                  setIsShowRelated(true);
                }}
              >
                관련도서등록
              </button>
              <RelatedBooks />
            </div>
          </li> */}
        </ul>
      </div>
      {/* {AdminBookInfomation(false, '1153')} */}
    </main>
  );
}
